<template>
  <div>
    <div style="background-color: #00a7d3">{{info}}</div>
    <v-card class="transparent elevation-0">
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12">
            <h1>Contractors</h1>
          </v-col>
        </v-row>

        <v-row justify="space-between" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
          <v-col cols="12" sm="12" md="3">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="3">
            <v-select
              :items="regions"
              item-text="name"
              return-object
              v-model="region"
              prepend-icon="fas fa-map"
              label="Region..."></v-select>
          </v-col>

          <v-col cols="12" sm="12" md="3">
            <v-switch
              style="justify-content: center"
              color="blue"
              v-model="activeOnlySwitch"
              :label="activeOnlySwitch ? 'Active Only' : 'Show All'"
            ></v-switch>
          </v-col>

          <v-col cols="12" sm="12" md="2" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn class="mx-2" fab dark color="blue lighten-1" @click="newContractor" v-on="on">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>Create a new contractor</span>
            </v-tooltip>
          </v-col>

        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :search="search"
        :loading="loading"
        :items="renderedContractors"
        :items-per-page="-1"
      >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}" @click="editRow(props.item)">
            <td style="text-align: center" v-for="(header, index) in headers" :key="index"
                v-if="header.value !== 'actions'">{{props.item[header.value]}}
            </td>
            <td v-else style="text-align: center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon color="blue" @click="editRow(props.item)" v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon color="red" v-on:click="deleteRow(props.item, $event)" v-on="on" class="pl-1">
                    delete
                  </v-icon>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this contractor. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
          <v-btn text @click="deleteContractor" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <EditContractor
      v-if="contractor"
      :contractor="contractor"
      :editDialog="editDialog"
      :region="region"
      :regionDepots="regionDepots"
      ref="editComponent"
      @close="closeEditDialog"
      @save="saveChanges"
    ></EditContractor>
  </div>
</template>

<script>
    import axios from 'axios';
    import EditContractor from './EditContractor';

    export default {
        name: "ContractorsDataTable",
        components: {
            EditContractor
        },
        data() {
            return {
                search: '',
                loading: false,
                toBeDeleted: null,
                deleteDialog: false,
                editDialog: false,
                contractor: null,
                activeOnlySwitch: true,
                reload: false,
                region: null,
                info:'',
                default: {
                    id: 0,
                    name: null,
                    legal_name: null,
                    abn: null,
                    address: null,
                    suburb: null,
                    state: null,
                    postcode: null,
                    contact_name: null,
                    contact_phone: null,
                    contact_email: null,
                    account_email:null,
                    gst_registered:null,
                    oracle_supplier_number:null,
                    oracle_supplier_name:null,

                    bank_details:{
                      bank_name:null,
                      bsb:null,
                      number:null,
                      remmitance_email:null,
                    },
                    active: false,
                },
            }
        },
        computed: {
            regions: function () {
                return this.$store.getters['auth/permissionRegions']('contractors_view');
            },

            renderedContractors() {
                if (this.contractors === null || this.contractors === undefined) return [];
                let bank_details = {
                  bank_name: null,
                  bsb: null,
                  number: null,
                  remmitance_email: null,
                }
                if (this.activeOnlySwitch) {
                    return this.contractors.filter((contractor) => {
                        contractor['bank_details'] = bank_details;
                        return contractor.active;
                    })
                } else {
                      this.contractors.filter((contractor) => {
                      return contractor['bank_details'] = bank_details;
                    });
                    return this.contractors;
                }
            },
            editPermission() {
                if (this.region === null) return false;
                return this.$store.getters['auth/hasPermissionRegion']('contractors_edit', this.region);
            },
            headers() {
                let headers = [
                    {text: 'Id', value: 'id', align: 'center', sortable: true, width: '5%'},
                    {text: 'Name', value: 'name', align: 'center', sortable: true, width: '15%'},
                    {text: 'Legal Name', value: 'legal_name', align: 'center', sortable: true, width: '25%'},
                    {text: 'ABN', value: 'abn', align: 'center', sortable: false, width: '10%'},
                    {text: 'Address', value: 'address', align: 'center', sortable: false, width: '12%'},
                    {text: 'Suburb', value: 'suburb', align: 'center', sortable: false, width: '10%'},
                    {text: 'State', value: 'state', align: 'center', sortable: false, width: '5%'},
                    {text: 'Postcode', value: 'postcode', align: 'center', sortable: false, width: '5%'},
                ];
                if (this.editPermission) headers.push({
                    text: 'Actions',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                    width: '10%'
                });
                return headers;
            }
        },
        asyncComputed: {
            async contractors() {
                if (this.reload || !this.reload) {
                    if (this.region === null || !this.$store.getters['auth/hasPermissionRegion']('contractors_view', this.region)) {
                        this.reload = false;
                        return [];
                    }
                    this.loading = true;
                    return await axios.get(process.env.API_URL + '/contractors/regions/' + this.region.id)
                        .then((response) => {
                            if (response.status === 200) {
                                this.loading = false;
                                this.reload = false;
                                return response.data;
                            } else {
                                this.loading = false;
                                return [];
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            this.reload = false;
                            return [];
                        });
                }
            },
            
            async regionDepots() {
              if (this.reload || !this.reload) {
                if (this.region === null || !this.$store.getters['auth/hasPermissionRegion']('contractors_view', this.region)) {
                    this.reload = false;
                    return [];
                }
                this.loading = true;
                return await axios.get(process.env.API_URL + '/regions/' + this.region.id + '/depots')
                .then((response) => {
                    if (response.status === 200) {
                        this.loading = false;
                        this.reload = false;
                        return response.data.filter((depot) => {
                            return depot.parent_depot === null;
                        });
                    } else {
                        this.loading = false;
                        return [];
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    this.reload = false;
                    return [];
                });
              }
            }
        },
        methods: {
            newContractor() {
                this.contractor = Object.assign({}, this.default);
                this.editDialog = true;
            },
            editRow(item) {
                this.contractor = Object.assign({}, item);
                this.editDialog = true;
            },
            deleteRow(item, event) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
                if (event) event.cancelBubble = true;
            },
            deleteContractor() {
                axios.delete(process.env.API_URL + '/contractors/' + this.toBeDeleted.id)
                    .then((response) => {
                        this.toBeDeleted = null;
                        this.deleteDialog = false;
                        this.reload = true;
                        this.$store.commit('displaySnackbar', 'Delete successful');
                    })
                    .catch((error) => {
                        this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
                    });
            },
            toggleDeleteDialog(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            closeEditDialog() {
                this.editDialog = false;
                this.contractor = null;
            },
            saveChanges() {
                if (this.contractor.id > 0) {
                  //this.info = this.contractor;
                    axios.put(process.env.API_URL + '/contractors/' + this.contractor.id, this.contractor)
                        .then((response) => {
                            this.editDialog = false;
                            this.contractor = null;
                            this.reload = true;
                            this.$store.commit('displaySnackbar', 'Save successful');
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar', 'ERROR: Save failed');
                        });
                } else {
                    axios.post(process.env.API_URL + '/contractors/regions/' + this.region.id, this.contractor)
                        .then((response) => {
                            this.editDialog = false;
                            this.contractor = null;
                            this.reload = true;
                            this.$store.commit('displaySnackbar', 'Create successful');
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar', 'ERROR: Create failed');
                        });
                }
            },
        },
        mounted() {
            this.region = this.regions[0];
        }
    }
</script>

<style scoped>
  .center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/util/Contractors/ContractorsDataTable.vue